import { PatientError } from '../../domain';

export class PatientValidator {
  isPatientError(e: Error): e is PatientError {
    return e instanceof PatientError;
  }
}
